import './Lander17.scss'

import { useEffect } from 'react'

import loaderImg from '../../../../../../assets/images/Lander17/loader.gif'
import { FONTS, loadFonts } from '../../../../../../utils/lazyFonts'
import generateSteps from './data/steps'
import { FallbackProvider } from './FallbackProvider'

const hasOption = slug => {
  const regex = new RegExp(`/17-(1|2|3|4)/.*${slug}`)
  return regex.test(window.location.href)
}

export default function Lander17(props) {
  const { nextStep, currentFormField, submitForm, handleNextStep, landerId } =
    props
  const steps = generateSteps()
  const isLastStep = currentFormField >= steps.length + 1
  const landerVersionClassName = `LanderContainer17 version${landerId}`
  const landerContentInnerClassName = `LanderContentInner17 version${landerId}`
  const hasSSO = hasOption('sso')

  useEffect(() => {
    loadFonts(FONTS.lander17)
  }, [])

  useEffect(() => {
    if (isLastStep) {
      submitForm()
    }
  }, [currentFormField])

  const currentStep = steps[Math.min(currentFormField, steps.length) - 1]
  const { component: CurrentStep } = currentStep || {}

  return (
    <div className={landerVersionClassName}>
      <div className="BackgroundOverlay17"></div>
      {isLastStep && (
        <div className="LoadingOverlay">
          <img src={loaderImg} alt="Loader" />
        </div>
      )}

      <form
        className="LanderContent"
        onSubmit={e => {
          e.preventDefault()

          if (currentStep.field) {
            handleNextStep([currentStep.field])
          }
        }}
      >
        <FallbackProvider>
          {CurrentStep && (
            <div className={landerContentInnerClassName}>
              <CurrentStep
                onNextStep={nextStep}
                handleNextStep={handleNextStep}
                hasSSO={hasSSO}
                {...props}
              />
            </div>
          )}
        </FallbackProvider>
      </form>
    </div>
  )
}
